export const imageCodes = {

    vMen: {
        code: "${merchantId}_tmpl_img_25",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fv%20men.png?alt=media&token=915088ff-247c-4b9e-86ea-13a32c65c8ce"
    },

    vGirl: {
        code: "${merchantId}_tmpl_img_18",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fv%20girl.png?alt=media&token=c4b6c2aa-38b7-4126-93bb-52d3ed4940d0"
    },
}

export const textCodes = {

    aboutUs: {
        code: "${merchantId}_tmpl_text_4",
        text: "လိုအပ်သော ဆေးဝါး အမျိုးမျိုးကို တစ်နေရာတည်းတွင် အမြန်ဆုံးနှင့် အလျှင်မြန်ဆုံး အလွယ်တကူ၀ယ်ယူနိုင်သော VCARE Pharmacy"
    },
}

export const titleCodes = {

    aboutVcare: {
        code: "${merchantId}_tmpl_text_2",
        title: "VCare Pharmacy"
    },
}